import script from "./TagProductDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./TagProductDrawer.vue?vue&type=script&setup=true&lang=js"

import "./TagProductDrawer.vue?vue&type=style&index=0&id=47803e6e&lang=scss"

const __exports__ = script;

export default __exports__